import { useNavigate } from 'react-router-dom';

interface PageHeaderProps {
  title: string;
  showBackButton?: boolean;
}

export function PageHeader({ title, showBackButton = true }: PageHeaderProps) {
  const navigate = useNavigate();

  return (
    <div className="sticky top-0 bg-white z-10 border-b border-gray-200">
      <div className="flex items-center justify-center px-4 py-3 relative">
        {showBackButton && (
          <button
            onClick={() => navigate(-1)}
            className="absolute left-4 p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <img src="/icons/icon_back.svg" alt="뒤로 가기" width="24" height="24" />
          </button>
        )}
        <h1 className="text-[24px] font-bold text-[#222222]">{title}</h1>
      </div>
    </div>
  );
}